import { useEffect, useState } from "react";
import { useOutletContext} from "react-router-dom";
import { getProfile } from "../../../services/api";
import { titleText } from "../../../components/utils/medstarAssociationTexts";
import { normalizeUserDemographics } from "../../../pageComponents/profilePages/normalization";
import { ErrorComponent, LoadingComponent } from "../../../sitel/demon/ui/molecules";
import Profile from "./profile";

/**
 * Component responsible for fetching a user's profile and taking action based on the fetched data.
 * Here I load the data, transform it and send to the profile form
 *
 * @returns {JSX.Element} The rendered JSX content.
 */
export default function UserProfilePage() {

    const { user } = useOutletContext();
    const userId = user.userId;
    const medstarAssociationType = user.medstar_association_type;
    const language = titleText(medstarAssociationType);
    const [userDemographics,setUserDemographics] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if(userId) {
            getProfile(
                userId,
                response => {
                    setIsLoading(false);
                    const userProfile = {...response.data.payload.user_demographics};
                    normalizeUserDemographics(userProfile)
                    console.log("userProfileuserDemographics",userProfile);
                    setUserDemographics(userProfile);
                },
                response => {
                    console.error('FAILED LOADING USER PROFILE',response);
                    setIsLoading(false);
                }
            );
        }
    },[userId])

      return (
        <>
          {isLoading ? (
            <LoadingComponent language={language} />
          ) : !userDemographics ? (
            <ErrorComponent language={language} />
          ) : (
            <Profile userProfile={userDemographics} medstarAssociationType={user.medstar_association_type}/>
          )}
        </>
      );
}
